import { Ad } from '../types/ad';
import { EHandlebars } from '../headers_footers/shared';
import { NewspaperOrderModel } from '../model/objects/newspaperOrderModel';
import { Classified } from '../types/classified';
import { EOrganization } from '../types';
import {
  DynamicSection,
  OrderFilingType,
  ProcessedDynamicSection
} from '../types/filingType';
import { Obituary } from '../types/obituary';
import { wrapError, wrapSuccess } from '../types/responses';
import { convertStyleNameToClassName } from './styles';

type OrderHandlebarsTemplateData = {
  madlibData: Ad['madlibData'];
  filingType?: OrderFilingType;
  publisherOrganization?: EOrganization;
};

export function generateTextFromHandlebarsTemplate({
  template,
  adContent,
  filingType,
  publisherOrganization
}: {
  template: string;
  adContent: Partial<Obituary> | Partial<Classified | Ad>;
  filingType?: OrderFilingType;
  publisherOrganization?: EOrganization;
}) {
  const textTemplate = EHandlebars.compile<OrderHandlebarsTemplateData>(
    template || ''
  );

  return textTemplate({
    madlibData: adContent.madlibData,
    filingType,
    publisherOrganization
  });
}

function generateDynamicSectionContent(
  section: DynamicSection,
  adContent: Partial<Obituary> | Partial<Classified>
): ProcessedDynamicSection {
  const content = generateTextFromHandlebarsTemplate({
    template: section.template || '',
    adContent
  });
  return {
    id: section.id,
    name: section.name,
    content,
    textClass: convertStyleNameToClassName(section.textStyle),
    objectClass: convertStyleNameToClassName(section.objectStyle)
  };
}

async function getDynamicSectionConfig(newspaperOrder: NewspaperOrderModel) {
  const [filingTypeError, filingType] = await newspaperOrder.getFilingType();
  if (filingTypeError) {
    return wrapError(filingTypeError);
  }

  if (!filingType.modelData.dynamicSections) {
    return wrapSuccess([]);
  }

  return wrapSuccess(filingType.modelData.dynamicSections);
}

export async function getDynamicSections(
  newspaperOrder: NewspaperOrderModel,
  adContent: Partial<Obituary> | Partial<Classified>
) {
  const [dynamicSectionsError, dynamicSections] = await getDynamicSectionConfig(
    newspaperOrder
  );
  if (dynamicSectionsError) {
    return wrapError(dynamicSectionsError);
  }

  const sections = dynamicSections.map(section =>
    generateDynamicSectionContent(section, adContent)
  );

  return wrapSuccess(sections);
}
